import React from "react";
import { v4 as uuidv4 } from 'uuid';

export const Switch = ({ className, id, ...otherProps }) => {
    const inputId = id ? id : uuidv4()
    const classes = className ? `${className} sui-switch` : 'sui-switch'
    return (
        <div className={classes}>
            <input id={inputId} className="sui-switch__native" type="checkbox" {...otherProps} />
            <label htmlFor={inputId} className="sui-switch__faux" />
        </div>
    )
}
